(function ($) {
    Drupal.behaviors.dataAnalyticsFilter = {
        attach: function (context, settings) {

            $("#dana_region", context).change(function () {
                var regionId = $(this).val();
                console.log("regionId: " + regionId);
                $("#ajax_loader").show();
                $.ajax({
                    method: "GET",
                    url: "/analytics-countries",
                    dataType: "json",
                    data: { id: regionId },
                    success: function (data) {
                        var countryOptions = '<option value="">None selected</option>';
                        $.each(data.countries, function (key, value) {
                           countryOptions += '<option value="' + key + '">' + value + '</option>';
                        });
                        $("#dana_country", context).html(countryOptions);

                        $("#ajax_loader").hide();
                    }
                });

            });

            $("#dana_nuaarea", context).change(function () {

                var areaId = $(this).val();
                console.log("areaId: " + areaId);

                $("#ajax_loader").show();
                $.ajax({
                    method: "GET",
                    url: "/analytics-nuaareas",
                    dataType: "json",
                    data: { id: areaId },
                    success: function (data) {
                        clearAreaDependent(context);
                        var countryOptions = '<option value="">None selected</option>';
                        $.each(data.areas, function (key, value) {
                            countryOptions += '<option value="' + key + '">' + value + '</option>';
                        });

                        $("#dana_indicators", context).html(countryOptions);
                        $("#ajax_loader").hide();
                        $('#dana_indicators').multiselect('rebuild');
                    }
                });

            });

            $("#dana_indicators", context).change(function () {
                var indicatorId = $(this).val();
                console.log("indicator: " + indicatorId);
                $("#ajax_loader").show();
                $.ajax({
                    method: "GET",
                    url: "/analytics-indicator-data",
                    dataType: "json",
                    data: { id: indicatorId },
                    success: function (data) {
                        clearIndicatorDependent(context);
                        loadIndicatorDependents(context, data);
                        //$(".downloaddata").attr('href', '/export-data?id='+indicatorId);
                        
                        //var activeTab = $("ul.list-group-chart-tabs li a.active");
                        if(data.best_suited_graph != null){
                            $("#"+ data.best_suited_graph).addClass('active');
                        }else{
                            $("#bar").addClass('active');
                        }
                        
                        $("#ajax_loader").hide();
                        $('.multiselect-control').multiselect({
                            enableFiltering: true,
                            enableCaseInsensitiveFiltering: true,
                            enableFullValueFiltering: false,
                            includeSelectAllOption: false,
                            maxHeight: 340,
                            buttonWidth: '100%',
                            onChange: function (option, checked) {
                                // Get selected options.
                                var selectedCountryOptions = $('#dana_country option:selected');
                                if (selectedCountryOptions.length >= 5) {
                                    // Disable all other checkboxes.
                                    var nonSelectedCountryOptions = $('#dana_country option').filter(function () {
                                        return !$(this).is(':selected');
                                    });
                                    nonSelectedCountryOptions.each(function () {
                                        var inputCountry = $('input[value="' + $(this).val() + '"]');
                                        inputCountry.prop('disabled', true);
                                        inputCountry.parent('li').addClass('disabled');
                                    });
                                }
                                else {
                                    // Enable all checkboxes.
                                    $('#dana_country option').each(function () {
                                        var inputCountry = $('input[value="' + $(this).val() + '"]');
                                        inputCountry.prop('disabled', false);
                                        inputCountry.parent('li').addClass('disabled');
                                    });
                                }
                                // Get selected options.
                                var selectedYearOptions = $('#dana_years option:selected');
                                if (selectedYearOptions.length >= 10) {
                                    // Disable all other checkboxes.
                                    var nonSelectedYearOptions = $('#dana_years option').filter(function () {
                                        return !$(this).is(':selected');
                                    });
                                    nonSelectedYearOptions.each(function () {
                                        var inputYear = $('input[value="' + $(this).val() + '"]');
                                        inputYear.prop('disabled', true);
                                        inputYear.parent('li').addClass('disabled');
                                    });
                                }
                                else {
                                    // Enable all checkboxes.
                                    $('#dana_years option').each(function () {
                                        var inputYear = $('input[value="' + $(this).val() + '"]');
                                        inputYear.prop('disabled', false);
                                        inputYear.parent('li').addClass('disabled');
                                    });
                                }
                            }
                        });
                    }
                });

            });

            // To reset the filters
            $("#reset-analytics-filter", context).click(function () {
                $("#analytics_filter_form").trigger("reset");
                $('#dana_country option:selected,#dana_years option:selected').each(function () {
                    $(this).prop('selected', false);
                });
                $('#dana_country,#dana_years').multiselect('refresh');

                $("#chartContainer").html('&nbsp;');
                $("#chartContainer").html('<canvas id="hbarChart" style="width:100%;height:500px"></canvas>');
                $("#barChartContainer").html('&nbsp;');
                $("#barChartContainer").html('<canvas id="vbarChart" style="width:100%;height:500px"></canvas>');
                $("#lineChartContainer").html('&nbsp;');
                $("#lineChartContainer").html('<canvas id="lineChart" style="width:100%;height:500px"></canvas>');
                $("#pieChartContainer").html('&nbsp;');
                $("#pieChartContainer").html('<canvas id="pieChart" style="width:100%;height:500px"></canvas>');
                $("#radarContainer").html('&nbsp;');
                $("#radarContainer").html('<canvas id="radarChart" style="width:100%;height:500px"></canvas>');
            });



            $("#apply-analytics-filter", context).click(function () {
                $("#ajax_loader").show();
                var formData = $('#analytics_filter_form').serialize();

                $.ajax({
                    method: "GET",
                    url: "/analytics-filter-data",
                    dataType: "json",
                    data: formData,
                    success: function (data) {
                        console.log(data);
                        var graph_name = $("#dana_indicators").find('option:selected').text();
                        var graph_color = ['#ea2128', '#c731d2', '#f3bd19', '#4abb5f', '#0000ff','#a1045a', '#4C9900', '#00FFFF', '#FF00FF','#FF8C00','#0000FF','#FF4500','#FF1493','#008B8B', '#000080','#63b8ff','#b0e0e6'];
                        
                        // to create horizontalBar chart
                        $("#chartContainer").html('&nbsp;');
                        $("#chartContainer").html('<canvas id="hbarChart" style="width:100%;height:500px"></canvas>');
                       
                        var horizontalBarConfig = horizontalBarChart(data, graph_color, graph_name);
                        var ctxHorizontal = document.getElementById('hbarChart').getContext('2d');
                        var buildHBarChart = new Chart(ctxHorizontal, horizontalBarConfig);
                       
                        // To create vertical bar chart
                        $("#barChartContainer").html('&nbsp;');
                        $("#barChartContainer").html('<canvas id="vbarChart" style="width:100%;height:500px"></canvas>');
                        
                        var barConfig = vbarChart(data, graph_color, graph_name);
                        var ctxBar = document.getElementById('vbarChart').getContext('2d');
                        var buildBarChart = new Chart(ctxBar, barConfig);
                        
                        // To create line chart
                        $("#lineChartContainer").html('&nbsp;');
                        $("#lineChartContainer").html('<canvas id="lineChart" style="width:100%;height:500px"></canvas>');
                        
                        var lineConfig =  lineChart(data, graph_color, graph_name); 
                        var ctxLine = document.getElementById('lineChart').getContext('2d');
                        var buildLineChart = new Chart(ctxLine, lineConfig);
                        
                        // To create pie chart
                        $("#pieChartContainer").html('&nbsp;');
                        $("#pieChartContainer").html('<canvas id="pieChart" style="width:100%;height:500px"></canvas>');
                        
                        var pieConfig = pieChart(data, graph_color, graph_name);
                        var ctxPie = document.getElementById('pieChart').getContext('2d');
                        var buildPieChart = new Chart(ctxPie, pieConfig);
                        
                        // To create radar Chart
                        $("#radarContainer").html('&nbsp;');
                        $("#radarContainer").html('<canvas id="radarChart" style="width:100%;height:500px"></canvas>');

                        var radarConfig = radarChart(data, graph_color, graph_name);
                        var ctxRadar = document.getElementById('radarChart').getContext('2d');
                        var buildRadarChart = new Chart(ctxRadar, radarConfig);
                        
                        
                        //var url = buildHBarChart.toBase64Image();
                        //$("#imgChart").src=url;
                        //document.getElementById("imgChart").src=url;
                         //console.log(url);
//                        $(".export-data").attr('href', '/export-data?'+formData);
//                        $(".export-data").attr('href', '/export-data?'+formData);
//                        $(".export-data").attr('href', '/export-data?'+formData);
//                        $(".export-data").attr('href', '/export-data?'+formData);
                        $(".export-data").attr('href', '/export-data?'+formData);
                        
                        $("#ajax_loader").hide();

                    }
                });

            });

        }

    };
})(jQuery);

function loadRegions(context, data) {

}

function loadIndicators(context, data) {
    
    var options = '<option value="">None selected</option>';
    $.each(data.areas, function (key, value) {
        options += '<option value="' + key + '">' + value + '</option>';
    });
    $("#dana_indicators", context).html(options);
}

function loadCountry(context, data) {
    var countryOptions = "<div class='multiselect-control-wrap'><select class='multiselect-control' data-placeholder='Select Country' name='countries[]' multiple='multiple' id='dana_country'>";

         if(typeof(data.country.World) !== 'undefined'){
            if(data.country.World.length > 0){
                countryOptions += '<optgroup label="World">';
                $.each(data.country.World, function (key, value) {
                    countryOptions += '<option value="' + value.id + '">' + value.country + '</option>';
                });
                countryOptions += '</optgroup>';
            }

        }
        
        if(typeof(data.country.Region) !== 'undefined'){
            if(data.country.Region.length > 0){
                countryOptions += '<optgroup label="Region">';
                $.each(data.country.Region, function (key, value) {
                    countryOptions += '<option value="' + value.id + '">' + value.country + '</option>';
                });
                countryOptions += '</optgroup>';
            }
        }
        if(typeof(data.country.Countries) !== 'undefined'){
            if(data.country.Countries.length > 0){
                countryOptions += '<optgroup label="Countries">';
                 $.each(data.country.Countries, function (key, value) {
                    if(value.id === 'null' || value.id === null || value.id === undefined){
                        countryOptions += '<option value="' + value.country + '">' + value.country + '</option>';
                    } else{
                       countryOptions += '<option value="' + value.id + '">' + value.country + '</option>';
                    }
                    
                });
                countryOptions += '</optgroup>';
            }
        }
        
    countryOptions += "</select></div>";
    $("#countries-da", context).html(countryOptions);
   
}

function loadYears(context, data) {
    var yearOptions = "<div class='multiselect-control-wrap'><select class='multiselect-control' data-placeholder='Select Year' name='years[]' multiple='multiple' id='dana_years'>";
    $.each(data.years, function (key, value) {
        yearOptions += '<option value="' + value.years + '">' + value.years + '</option>';
    });
    yearOptions += "</select></div>";
    $("#years-da", context).html(yearOptions);
}

function loadUnits(context, data) {
    var unitOptions = '<option value="">None selected</option>';
    $.each(data.units, function (key, value) {
        unitOptions += '<option value="' + value.units + '">' + value.units + '</option>';
    });
    $("#dana_units", context).html(unitOptions);
}

function loadAge(context, data) {
    
    if(data.age.length > 0){
        $("#ageContainer").hide();
        var ageOptions = '<option value="">None selected</option>';
        $.each(data.age, function (key, value) {
            ageOptions += '<option value="' + value.age + '">' + value.age + '</option>';
        });
        $("#dana_age", context).html(ageOptions);
    }else{
        $("#ageContainer").hide();
    }
}

function loadGender(context, data) {
   
    if(data.gender.length > 0){
        $("#genderContainer").hide();
    
        var genderOptions = '<option value="">None selected</option>';
        $.each(data.gender, function (key, value) {
            genderOptions += '<option value="' + value.sex + '">' + value.sex + '</option>';
        });
        $("#dana_gender", context).html(genderOptions);
    }else{
        $("#genderContainer").hide();
    }
}

function loadIndicatorDependents(context, data) {
    loadCountry(context, data);
    loadYears(context, data);
    loadUnits(context, data);
    loadAge(context, data);
    loadGender(context, data);
}

function clearAreaDependent(context) {
    $("#dana_indicators", context).html('<option >None Selected</option>');
    clearIndicatorDependent(context);
}

function clearIndicatorDependent(context) {
    $("#countries-da", context).html("<div class='multiselect-control-wrap'><select class='multiselect-control' data-placeholder='Select Country' name='countries[]' multiple='multiple' id='dana_country'><option >None Selected</option></select></div>");
    $("#years-da", context).html("<div class='multiselect-control-wrap'><select class='multiselect-control' data-placeholder='Select Year' name='years[]' multiple='multiple' id='dana_years'><option >None Selected</option></select></div>");
    $("#dana_age", context).html('<option >None Selected</option>');
    $("#dana_gender", context).html('<option >None Selected</option>');
    $("#dana_units", context).html('<option >None Selected</option>');

    $('#dana_country option:selected,#dana_years option:selected').each(function () {
        $(this).prop('selected', false);
    });
    $('#dana_country,#dana_years').multiselect('refresh');
}

function vbarChart(data, graph_color, graph_name) {

    var graph_dataset = [];
    var graph_labels = [];
    var graph_xlabel = '';
    var graph_ylabel = '';
    var max = 100;
    var datasetObj = {};
    

    if (data.result.vbar !== null) {

        graph_labels = data.result.vbar.labels;
        graph_xlabel = data.result.vbar.xAxisLable;
        graph_ylabel = data.result.vbar.yAxisLable;
        
        if(graph_ylabel === 'NUMBER'){
            max = data.result.vbar.max;
        }

        $.each(data.result.vbar.label, function (key, value) {
            datasetObj = {
                label: value,
                backgroundColor: graph_color[key],
                borderColor: graph_color[key],
                borderWidth: 1,
                data: data.result.vbar.dataset[value]
            };

            graph_dataset.push(datasetObj);
        });
    }

    var configOptions = {
        type: 'bar',
        data: {
            labels: graph_labels,
            datasets: graph_dataset,
        },
        options: {
            title: {
                display: true,
                text: graph_name,
                position: 'top',
                align: 'start',
                fontStyle: 'bold',
                fontSize: '15' 
            },
            legend: {
                display: true,
                position: 'right',
                align: 'center'
            },
            scales: {
                xAxes: [{
                    gridLines: {
                        drawOnChartArea: false
                    },
                    scaleLabel: {
                        display: true,
                        labelString: graph_xlabel,
                        fontStyle: 'bold',
                        fontSize: '14' 
                    }
                }],
                yAxes: [{
                    ticks: {
                        beginAtZero: true,
                        max: max,
                        min: 0
                    },
                    scaleLabel: {
                        display: true,
                        labelString: graph_ylabel,
                        fontStyle: 'bold',
                        fontSize: '14' 
                    },
                    gridLines: {
                        drawOnChartArea: false
                    }
                }]
            }

        }
    };
    
    return configOptions ;
  //$("#ajax_loader").hide();
}

function horizontalBarChart(data, graph_color, graph_name) {

    var graph_dataset = [];
    var graph_labels = [];
    var graph_xlabel = '';
    var graph_ylabel = '';
    var max = 100;
    var datasetObj = {};

    if (data.result.hbar !== null) {

        graph_labels = data.result.hbar.labels;
        graph_xlabel = data.result.hbar.xAxisLable;
        graph_ylabel = data.result.hbar.yAxisLable;
        
        if(graph_xlabel === 'NUMBER'){
            max = data.result.hbar.max;
        }

        $.each(data.result.hbar.label, function (key, value) {
            datasetObj = {
                label: value,
                backgroundColor: graph_color[key],
                borderColor: graph_color[key],
                borderWidth: 1,
                data: data.result.hbar.dataset[value]
            };

            graph_dataset.push(datasetObj);
            
        });
        
    }
console.log(graph_dataset);
    var configOptions = {
        type: 'horizontalBar',
        data: {
            labels: graph_labels,
            datasets: graph_dataset,
        },
        options: {
            title: {
                display: true,
                text: graph_name,
                position: 'top',
                align: 'start',
                fontStyle: 'bold',
                fontSize: '15' 
            },
            legend: {
                display: true,
                position: 'right',
                align: 'center'
            },
            scales: {
                xAxes: [{
                    ticks: {
                        beginAtZero: true,
                        max: max,
                        min: 0
                    },
                    gridLines: {
                        drawOnChartArea: false
                    },
                    scaleLabel: {
                        display: true,
                        labelString: graph_xlabel,
                        fontStyle: 'bold',
                        fontSize: '14' 
                    }
                }],
                yAxes: [{
                    scaleLabel: {
                        display: true,
                        labelString: graph_ylabel,
                        fontStyle: 'bold',
                        fontSize: '14' 
                    },
                    gridLines: {
                        drawOnChartArea: false
                    }
                }]
            }

        }
    };

    return configOptions;
    //$("#ajax_loader").hide();
}

function lineChart(data, graph_color, graph_name){
    var graph_dataset = [];
    var graph_labels = [];
    var graph_xlabel = '';
    var graph_ylabel = '';
    var max = 100;
    var datasetObj = {};
    
    if (data.result.vbar !== null) {

        graph_labels = data.result.vbar.labels;
        graph_xlabel = data.result.vbar.xAxisLable;
        graph_ylabel = data.result.vbar.yAxisLable;
        
        if(graph_xlabel === 'NUMBER'){
            max = data.result.vbar.max;
        }
        
        $.each(data.result.vbar.label, function (key, value) {
            datasetObj = {
                label: value,
                backgroundColor: graph_color[key],
                borderColor: graph_color[key],
                borderWidth: 1,
                data: data.result.vbar.dataset[value],
                fill: false
            };

            graph_dataset.push(datasetObj);
        });
    }
    console.log(graph_dataset);
    
    var configOptions = {
        type: 'line',
        data: {
           labels: graph_labels,
           datasets: graph_dataset,
       },
       options: {
        responsive: true,
        title: {
            display: true,
            text: graph_name,
            position: 'top',
            align: 'start',
            fontStyle: 'bold',
            fontSize: '15' 
        },
        legend: {
            display: true,
            position: 'right',
            align: 'center'
        },
        tooltips: {
          mode: 'label',
        },
        hover: {
          mode: 'nearest',
          intersect: true
        },
        scales: {
          xAxes: [{
            ticks: {
                beginAtZero: true,
                max: max,
                min: 0
            },      
            display: true,
            scaleLabel: {
                display: true,
                labelString: graph_xlabel,
                fontStyle: 'bold',
                fontSize: '14' 
            },
            gridLines: {
                drawOnChartArea: false
            }
          }],
          yAxes: [{
            display: true,
            scaleLabel: {
                display: true,
                labelString: graph_ylabel,
                fontStyle: 'bold',
                fontSize: '14' 
            },
            gridLines: {
                drawOnChartArea: false
            }
          }]
        }
      }
    };
    
    return configOptions;
    //$("#ajax_loader").hide();
}

function pieChart(data, graph_color, graph_name){
    var graph_dataset = [];
    var graph_labels = [];
    var graph_xlabel = '';
    var graph_ylabel = '';
    var datasetObj = {};
    
    if (data.result.pie !== null) {

        graph_labels = data.result.pie.label;
        graph_xlabel = data.result.pie.xAxisLable;
        graph_ylabel = data.result.pie.yAxisLable;
        
        $.each(data.result.pie.label, function (key, value) {
            var borderColor = graph_color[key];
            var backgroundColor = graph_color[key] + '33';
            datasetObj = {
                backgroundColor: graph_color,
                data: data.result.pie.dataset[value]
            };

            graph_dataset.push(datasetObj);
        });
    }
    
    
    var configOptions = {
        type: 'pie',
        data: {
           labels: graph_labels,
           datasets: graph_dataset
        },
        options: {
            responsive: true,
            title: {
              display: true,
              text: graph_name,
              position: 'top',
              align: 'start',
              fontStyle: 'bold',
              fontSize: '15' 
            },
            legend: {
                display: true,
                position: 'right',
                align: 'center'
            },
            plugins: {
              datalabels: {
                display: true,
                align: 'bottom',
                backgroundColor: '#ccc',
                borderRadius: 3,
                font: {
                  size: 18,
                }
              },
            }
        }
      };
     
     return configOptions;
     //$("#ajax_loader").hide();
      
}

function radarChart(data, graph_color, graph_name) {

    var graph_dataset = [];
    var graph_labels = [];
    var graph_xlabel = '';
    var graph_ylabel = '';
    var datasetObj = {};

    if (data.result.vbar !== null) {

        graph_labels = data.result.vbar.labels;
        graph_xlabel = data.result.vbar.xAxisLable;
        graph_ylabel = data.result.vbar.yAxisLable;

        $.each(data.result.vbar.label, function (key, value) {
            
            var borderColor = graph_color[key];
            var backgroundColor = graph_color[key] + '50';
            datasetObj = {
                label: value,
                backgroundColor:backgroundColor,
                borderColor: borderColor,
                pointBackgroundColor: borderColor,
                pointBorderColor: "#fff",
                pointHoverBackgroundColor: "#fff",
                pointHoverBorderColor: borderColor,
                data: data.result.vbar.dataset[value]
            };

            graph_dataset.push(datasetObj);
        });
    }

    var configOptions = {
        type: 'radar',
        data: {
            labels: graph_labels,
            datasets: graph_dataset,
        },
        options: {
            title: {
                display: true,
                text: graph_name,
                position: 'top',
                align: 'start',
                fontStyle: 'bold',
                fontSize: '15' 
            },
            legend: {
                display: true,
                position: 'right',
                align: 'center'
                
            },
        }
    };
    return configOptions;
   //$("#ajax_loader").hide();
}








